import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { AdminSpacesCreate } from '@components/templates/admin/spaces';

export const CreateSpace = () => {
    const { t } = useTranslation();

    const translations = {
        title: t('admin.spaces-management-create.metatags.title'),
        description: t('admin.spaces-management-create.metatags.description'),
    };

    useSEOMetatags({
        ...translations,
        url: SITE_URLS.createSpace,
        index: false,
    });

    return <AdminSpacesCreate />;
};
